import type { WizardState } from "./wizard-state.js";

/** Keep the local time zone with the instant; UTC alone loses morning/evening. */
export function wizardTime(
  state: Pick<WizardState, "playedAt" | "playedAtEdited">,
  now = new Date(),
) {
  const date = state.playedAtEdited ? new Date(state.playedAt) : now;
  if (!Number.isFinite(date.getTime()))
    throw new Error("Choose a valid date and time.");
  return {
    playedAt: date.toISOString(),
    playedAtTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
